document.addEventListener('DOMContentLoaded', function () {
  // Placeholder for future cart-drawer / AJAX interactions.
  // Currently the theme uses standard form posts for cart and product forms,
  // so no JS is required for core purchase flows to work.
});
